import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap";

import queryString from "query-string";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation-safe";

// action
import { userResetPassword } from "../../store/actions";

// import images
import logo from "../../assets/images/logo.png";

import { useGlobal } from "../../contexts/globalContext";

const ResetarSenha = (props) => {
  const { global } = useGlobal();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    const values = queryString.parse(props.location.search);

    if (values.email) {
      setEmail(values.email);
    }

    if (values.token) {
      setToken(values.token);
    }
  }, [props.location.search]);

  function handleValidSubmit(event, values) {
    Object.assign(values, { email });
    props.userResetPassword(values, props.history);
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block"></div>
      <div className="account-pages my-5">
        <Container>
          <div className="text-center">
            <h2>{global.ambiente}</h2>
          </div>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4"></div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="profile-user-wid mb-40">
                        <span className="avatar-title rounded-circle bg-transparent">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="120"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {props.resetError && props.resetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {props.resetError}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal mt-40"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="form-group">
                        <AvField
                          name="token"
                          label="Token"
                          className="form-control"
                          placeholder="Informe o token recebido por email"
                          type="text"
                          value={token}
                          maxLength={6}
                          required
                          errorMessage="Token não informado"
                        />
                      </div>

                      <div className="form-group">
                        <AvField
                          name="senha"
                          label="Senha"
                          className="form-control"
                          placeholder="Informe sua nova senha"
                          type="password"
                          required
                          errorMessage="Senha não informada"
                        />
                      </div>

                      <div className="form-group">
                        <AvField
                          name="senhaConfirmar"
                          label="Repita a Senha"
                          className="form-control"
                          placeholder="Confirme a sua nova senha"
                          type="password"
                          required
                          errorMessage="Confirmar Senha não informada"
                        />
                      </div>
                      <Row className="form-group">
                        <Col className="text-right">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Registrar Senha
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-50 text-center">
                <p>
                  Voltar para o{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  <Link
                    to={`/`}
                    onClick={(event) => {
                      event.preventDefault();
                      window.open("https://catec.inf.br/", "_blank");
                    }}
                    style={{ color: "#495057" }}
                  >
                    © {new Date().getFullYear()} {global.fabricante}
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { resetError, resetSuccessMsg } = state.ResetPassword;
  return { resetError, resetSuccessMsg };
};

export default withRouter(
  connect(mapStatetoProps, { userResetPassword })(ResetarSenha)
);
